<template>
  <v-container class="pa-2">
    <distributor-for-manager />
  </v-container>
</template>

<script>
import DistributorForManager from "./DistributorForManager";
import { mapState } from "vuex";
export default {
  name: "DistributorMain",
  components: {
    DistributorForManager,
  },
  data: () => ({
    role: "Sales",
  }),
  computed: {
    ...mapState(["user"]),
  },
};
</script>

<style lang="sass"></style>
